import React from 'react'
import styled from 'styled-components'
import { ThemeColor } from 'theme/colors'
import { Icon } from 'components/styled/icon'
import { PopoverTooltip } from 'components/styled/popover/tooltip'
import { ThemeSpace } from 'theme/spaces'

interface CustomTooltipProps {
  icon?: string
  id?: string
  color?: ThemeColor
  width?: ThemeSpace
  maxHeight?: ThemeSpace
  onClick?: () => void
  interaction?: 'onClick' | 'onHover'
  modalPopover?: boolean
}

const StyledCustomTooltip = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding-left: ${({ theme }) => theme.space.s8};
`

export const CustomTooltip: React.FC<CustomTooltipProps> = ({
  children,
  icon = 'help',
  id = '',
  width,
  color = 'grey90',
  onClick,
  maxHeight,
  interaction = 'onClick',
  modalPopover = false,
}) => {
  const trigger = (
    <div id={id} style={{ display: 'flex' }}>
      <Icon type={icon} size="s16" color={color} />
    </div>
  )

  return (
    <StyledCustomTooltip onClick={onClick}>
      <PopoverTooltip
        trigger={trigger}
        width={width}
        maxHeight={maxHeight}
        interaction={interaction}
        modalPopover={modalPopover}
      >
        {children}
      </PopoverTooltip>
    </StyledCustomTooltip>
  )
}
